/** Church-scoped cache keys so a switch never shows the previous tenant's dashboard. */
export const dashboardLayoutsQueryKey = (churchId: string | null | undefined) =>
  ['church', churchId, 'dashboard-layouts'] as const;

export const dashboardDataQueryKey = (
  churchId: string | null | undefined,
  dateFrom?: string | null,
  dateTo?: string | null,
) => ['church', churchId, 'dashboard', dateFrom ?? undefined, dateTo ?? undefined] as const;

/** @deprecated Use `dashboardLayoutsQueryKey(churchId)` — layouts are per church. */
export const DASHBOARD_LAYOUTS_QUERY_KEY = ['dashboard-layouts'] as const;

export type DashboardWidgetCategory =
  | 'finance'
  | 'people'
  | 'attendance'
  | 'communication'
  | 'groups'
  | 'spending'
  | 'programs'
  | 'content';

export interface DashboardLayoutRecord {
  id: string;
  name: string;
  widgets: string[];
  createdAt: string;
  updatedAt: string;
}

export interface DashboardLayoutsResponse {
  activeLayoutId: string;
  maxLayouts: number;
  maxWidgetsPerLayout: number;
  defaultWidgetKeys: string[];
  availableWidgets: Array<{
    key: string;
    kind: 'metric' | 'chart' | 'section';
    category: DashboardWidgetCategory;
    nameKey: string;
  }>;
  layouts: DashboardLayoutRecord[];
}
